export default {
  "root": "_root_64f5z_1",
  "touch": "_touch_64f5z_1",
  "--inset": "_--inset_64f5z_1",
  "--disabled-focus-ring": "_--disabled-focus-ring_64f5z_1",
  "--radius-inherit": "_--radius-inherit_64f5z_1",
  "--disabled": "_--disabled_64f5z_1",
  "--full-width": "_--full-width_64f5z_1"
};import "ni:sha-256;LZthi6bzeXhI4zxycQeV4FFTijZ2XMnE9qtlQiyOFgI";